export const districts = [
  {
    key: 'guliston',
    value: 'Гулистон',
  },
  {
    key: 'tabashar',
    value: 'Табошар',
  },
  {
    key: 'mastchoh_kuhi',
    value: 'Мастчохи кухи',
  },
  {
    key: 'khorog',
    value: 'Хорог',
  },
  {
    key: 'shughnan',
    value: 'Шугнан',
  },
  {
    key: 'rushan',
    value: 'Рушан',
  },
  {
    key: 'darvaz',
    value: 'Дарваз',
  },
  {
    key: 'roshtkala',
    value: 'Рошткала',
  },
  {
    key: 'murgab',
    value: 'Мургаб',
  },
  {
    key: 'ishkashim',
    value: 'Ишкашим',
  },
  {
    key: 'vanj',
    value: 'Вандж',
  },
  {
    key: 'lyakhsh',
    value: 'Ляхш',
  },
  {
    key: 'sangvor',
    value: 'Сангвор',
  },
  {
    key: 'norabad',
    value: 'Нурабад',
  },
  {
    key: 'shamsiddin_shohin',
    value: 'Шамсиддин Шохин',
  },
  {
    key: 'jamoliddini_balhi',
    value: 'Джалолиддини Балхи',
  },
  {
    key: 'baljuvon',
    value: 'Балджувон',
  },
  {
    key: 'ayni',
    value: 'Айни',
  },
  {
    key: 'varzob',
    value: 'Варзоб',
  },
  {
    key: 'asht',
    value: 'Ашт',
  },
  {
    key: 'b_gafurov',
    value: 'Б.Гафуров',
  },
  {
    key: 'bokhtar',
    value: 'Бохтар',
  },
  {
    key: 'dangara',
    value: 'Дангара',
  },
  {
    key: 'devashtich',
    value: 'Деваштич',
  },
  {
    key: 'dushanbe',
    value: 'Душанбе',
  },
  {
    key: 'dusti',
    value: 'Дусти',
  },
  {
    key: 'farkhor',
    value: 'Фархор',
  },
  {
    key: 'farovon',
    value: 'Фаровон',
  },
  {
    key: 'hamadoni',
    value: 'Хамадони',
  },
  {
    key: 'hissor',
    value: 'Гиссар',
  },
  {
    key: 'isfara',
    value: 'Исфара',
  },
  {
    key: 'istaravshan',
    value: 'Истаравшан',
  },
  {
    key: 'balkhi',
    value: 'Дж.Балхи',
  },
  {
    key: 'rasulov',
    value: 'Дж.Расулов',
  },
  {
    key: 'jayhun',
    value: 'Джайхун',
  },
  {
    key: 'jomi',
    value: 'Джоми',
  },
  {
    key: 'khujand',
    value: 'Худжанд',
  },
  {
    key: 'khuroson',
    value: 'Хуросон',
  },
  {
    key: 'konibodom',
    value: 'Канибадам',
  },
  {
    key: 'qubodiyon',
    value: 'Кубодийон',
  },
  {
    key: 'kulob',
    value: 'Куляб',
  },
  {
    key: 'mastchoh',
    value: 'Мастчох',
  },
  {
    key: 'muminabad',
    value: 'Муминобод',
  },
  {
    key: 'panj',
    value: 'Пандж',
  },
  {
    key: 'panjakent',
    value: 'Пенджикент',
  },
  {
    key: 'rudaki',
    value: 'Рудаки',
  },
  {
    key: 'shahriston',
    value: 'Шахристон',
  },
  {
    key: 'shahrituz',
    value: 'Шахритуз',
  },
  {
    key: 'somon',
    value: 'Сомон',
  },
  {
    key: 'spitamen',
    value: 'Спитамен',
  },
  {
    key: 'temurmalik',
    value: 'Темурмалик',
  },
  {
    key: 'tursunzoda',
    value: 'Турсунзода',
  },
  {
    key: 'vahdat',
    value: 'Вахдат',
  },
  {
    key: 'vose',
    value: 'Восеъ',
  },
  {
    key: 'yovon',
    value: 'Евон',
  },
  {
    key: 'zafarobod',
    value: 'Зафаробод',
  },
  {
    key: 'norak',
    value: 'Нурек',
  },
  {
    key: 'buston',
    value: 'Бустон',
  },
  {
    key: 'shahrinav',
    value: 'Шахринав',
  },
  {
    key: 'nawkat',
    value: 'Навкат',
  },
  {
    key: 'vakhsh',
    value: 'Вахш',
  },
  {
    key: 'korvon',
    value: 'Корвон',
  },
  {
    key: 'faizabad',
    value: 'Файзобод',
  },
  {
    key: 'nosiri_khusrav',
    value: 'Носири Хусрав',
  },
  {
    key: 'tojikobod',
    value: 'Тоҷикобод',
  },
  {
    key: 'nurobod',
    value: 'Нуробод',
  },
  {
    key: 'rasht',
    value: 'Рашт',
  },
].sort((a, b) => a.value.localeCompare(b.value));

export const districtsCollateral = [
  // {
  //   key: 'sino',
  //   value: 'Сино',
  // },
  // {
  //   key: 'khujand',
  //   value: 'Худжанд',
  // },
  // {
  //   key: 'firdavsi',
  //   value: 'Фирдавси',
  // },
  // {
  //   key: 'b_gafurov',
  //   value: 'Б. Гафуров',
  // },
  // {
  //   key: 'shokhmansur',
  //   value: 'Шохмансур',
  // },
  // {
  //   key: 'konibodom',
  //   value: 'Конибодом',
  // },
  // {
  //   key: 'norak',
  //   value: 'Норак',
  // },
  // {
  //   key: 'jaloliddini_balhi',
  //   value: 'Джалолиддини Балхи',
  // },
  // {
  //   key: 'hamadoni',
  //   value: 'Хамадони',
  // },
  // {
  //   key: 'vanj',
  //   value: 'Вандж',
  // },
  // {
  //   key: 'jomi',
  //   value: 'Джоми',
  // },
  // {
  //   key: 'vakhsh',
  //   value: 'Вахш',
  // },
  // {
  //   key: 'jayhun',
  //   value: 'Джайхун',
  // },
  // {
  //   key: 'dusti',
  //   value: 'Дусти',
  // },
  {
    key: 'dushanbe',
    value: 'Душанбе',
  },
  // {
  //   key: 'rudaki',
  //   value: 'Рудаки',
  // },
  // {
  //   key: 'bokhtar',
  //   value: 'Бохтар',
  // },
  // {
  //   key: 'guliston',
  //   value: 'Гулистон',
  // },
  // {
  //   key: 'mastchoh_kuhi',
  //   value: 'Мастчохи Кухи',
  // },
  // {
  //   key: 'tojikobod',
  //   value: 'Таджикабад',
  // },
  // {
  //   key: 'ismoili_somoni',
  //   value: 'Исмоили Сомони',
  // },
  // {
  //   key: 'spitamen',
  //   value: 'Спитамен',
  // },
  // {
  //   key: 'hisor',
  //   value: 'Хисор',
  // },
  // {
  //   key: 'buston',
  //   value: 'Бустон',
  // },
  // {
  //   key: 'zafarobod',
  //   value: 'Зафаробод',
  // },
  // {
  //   key: 'vahdat',
  //   value: 'Вахдат',
  // },
  // {
  //   key: 'tursunzoda',
  //   value: 'Турсунзода',
  // },
  // {
  //   key: 'temurmalik',
  //   value: 'Темурмалик',
  // },
  // {
  //   key: 'shakhrinav',
  //   value: 'Шахринав',
  // },
  // {
  //   key: 'panjakent',
  //   value: 'Пенджикент',
  // },
  // {
  //   key: 'varzob',
  //   value: 'Варзоб',
  // },
  // {
  //   key: 'istaravshan',
  //   value: 'Истаравшан',
  // },
  // {
  //   key: 'khuroson',
  //   value: 'Хуросон',
  // },
  // {
  //   key: 'vose',
  //   value: 'Восе',
  // },
  // {
  //   key: 'khorog',
  //   value: 'Хорог',
  // },
  // {
  //   key: 'faizobod',
  //   value: 'Файзабад',
  // },
  // {
  //   key: 'rasht',
  //   value: 'Рашт',
  // },
  // {
  //   key: 'khovaling',
  //   value: 'Ховалинг',
  // },
  // {
  //   key: 'shughnon',
  //   value: 'Шугнон',
  // },
  // {
  //   key: 'asht',
  //   value: 'Ашт',
  // },
  // {
  //   key: 'yovon',
  //   value: 'Яван',
  // },
  // {
  //   key: 'farkhor',
  //   value: 'Фархор',
  // },
  // {
  //   key: 'panj',
  //   value: 'Пяндж',
  // },
  // {
  //   key: 'levakan',
  //   value: 'Леваканд',
  // },
  // {
  //   key: 'kushoniyon',
  //   value: 'Кушониён',
  // },
  // {
  //   key: 'nosiri_khusrav',
  //   value: 'Носири Хусрав',
  // },
  // {
  //   key: 'shamsiddin_shohin',
  //   value: 'Шамсиддин Шохин',
  // },
  // {
  //   key: 'darvoz',
  //   value: 'Дарвоз',
  // },
  // {
  //   key: 'danghara',
  //   value: 'Дангара',
  // },
  // {
  //   key: 'rogun',
  //   value: 'Рогун',
  // },
  // {
  //   key: 'roshkala',
  //   value: 'Рошткала',
  // },
  // {
  //   key: 'muminobod',
  //   value: 'Муминабад',
  // },
  // {
  //   key: 'nurobod',
  //   value: 'Нуробод',
  // },
  // {
  //   key: 'shahrtuz',
  //   value: 'Шахритус',
  // },
  // {
  //   key: 'kabodiyon',
  //   value: 'Кабодиён',
  // },
  // {
  //   key: 'baljuvon',
  //   value: 'Балджувон',
  // },
  // {
  //   key: 'istiqlol',
  //   value: 'Истиклол',
  // },
  // {
  //   key: 'devashtich',
  //   value: 'Деваштич',
  // },
  // {
  //   key: 'ishkoshim',
  //   value: 'Ишкошим',
  // },
  // {
  //   key: 'rushon',
  //   value: 'Рушон',
  // },
  // {
  //   key: 'ayni',
  //   value: 'Айни',
  // },
].sort((a, b) => a.value.localeCompare(b.value));
